import { useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { recaptchaSiteKey } from "../../Environments/environment";

export default function ReCaptchaField({
  onVerify,
  className = "flex justify-center",
}) {
  const captchaRef = useRef(null);

  // Debug log
  if (!recaptchaSiteKey) {
    console.error("reCAPTCHA site key missing");
  }

  const handleChange = (token) => {
    if (onVerify) {
      onVerify(token);
    }
  };

  const handleExpired = () => {
    if (onVerify) {
      onVerify(null);
    }
  };

  return (
    <div className={className}>
      <ReCAPTCHA
        ref={captchaRef}
        sitekey={recaptchaSiteKey}
        onChange={handleChange}
        onExpired={handleExpired}
      />
    </div>
  );
}